module.exports = __webpack_public_path__ + "static/media/locations-top-image.288d22dc.png";